(function () {
  const blocks = document.querySelectorAll('.section-multitile__block.block-tile_6g89ng');
  blocks.forEach(block => {
    if (block.classList.contains('js-inline-icon-done')) return;

    const title = block.querySelector('.block-tile_6g89ng .section-multitile__content h2');
    const mediaImg = block.querySelector('.block-tile_6g89ng .section-multitile__media img');

    if (!title || !mediaImg) return;

    // Only do this for the Bone Broths tile (adjust the check if needed)
    const titleText = title.textContent.trim().toUpperCase();
    if (!titleText.startsWith('BONE BROTHS')) return;

    // Clone the media image into the H2
    const clone = mediaImg.cloneNode(true);
    clone.classList.add('inline-bone');
    title.prepend(clone);

    // Mark processed + hide the original media in this block
    block.classList.add('js-inline-icon-done');
  });
})();